/**
 * Controller for managing notifications.
 */

/**
 * @class ChargeHasEndedController
 * Initializes a new instance of the ChargeHasEndedController.
 */
function ChargeHasEndedController() {
    // Initialize the controller
    this.init.apply(this, arguments);
}

// Dependency injection for the controller
ChargeHasEndedController.$inject = ['$rootScope', 'NotificationService', '$message', '$Loading'];


// Define the prototype methods for NotificationsCtrl
ChargeHasEndedController.prototype = {
    /**
     * @type {number} case - for checking case
     */
    case: 1,
    /**
     * @type {NotificationModel} notification
     */
    notification: {},
    /**
     * Initializes the controller with necessary services and scope.
     * @param {angular.IRootScopeService} $rootScope
     * @param {NotificationService} NotificationService
     * @param {$message} $message
     * @param {$Loading} $Loading
     */
    init: function ($rootScope, NotificationService, $message, $Loading) {
        this.$rootScope = $rootScope;
        this.notificationService = NotificationService;
        this.$message = $message;
        this.$Loading = $Loading;

        this.case = this.notification.PendingChargeRequests ? 1 : 2;

        // Map notification to NotificationModel
        this.notification = this.notificationService.mapNotification(this.notification);
    },


    /**
     * Make a snooze for this notification
     * Storage snooze time
     * @param delay{number}
     */
    snooze: function (delay) {
        // Mark notification as read
        this.notificationService.snoozeNotification(this.notification, delay)
            .then(() => {
                this.close();
            }, this.$message.error)
            .finally(this.$Loading.blockUI());
    },

    /**
     * Mark a charging point as free and mark notification as read
     */
    markChargingPointAsFree: function () {
        // Call the service to mark the charging point as free
        this.notificationService.markChargingPointAsFree(this.notification.Id)
            .then(() => {
                this.$rootScope.$broadcast('refresh-home-data');

                this.close();
            }, this.$message.error) // Handle error for marking charging point as free
            .finally(this.$Loading.blockUI());
    },

    /**
     * Don't mark a charging point as free and mark notification as read
     */
    markNotificationAsRead: function () {
        this.notificationService.markAsRead(this.notification.Id)
            .then(() => {
                this.close();
            }, this.$message.error)
            .finally(this.$Loading.blockUI());
    }
};


// Register the ChargeHasEndedController controller with the AngularJS module
angular.module('internal.notifications').controller('ChargeHasEndedController', ChargeHasEndedController);